import React, { useState } from "react";
import CatSket from "../Skeletons/CatSket";
import { displayImage } from "../../helpers/config";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

function CategoryBox({ loading = true, data }) {
    const [imageLoading, setImageLoading] = useState(true)

    if (loading) {
        return (
            <>
                <CatSket />
            </>
        )
    }

    return (
        <div className="w-full flex flex-col items-center gap-2">
            {/* image */}
            <Link to={`/product-category/${data?.name?.toLowerCase()}`}>
                <div className="overflow-hidden size-28 lg:size-40 rounded-full cursor-pointer relative">
                    <AnimatePresence>
                        {imageLoading && (
                            <div
                                className="absolute z-50 w-full h-full top-0 left-0 right-0 bottom-0 animate-pulse bg-gradient-to-r from-gray-50 to-white" />
                        )}
                    </AnimatePresence>
                    <motion.img
                        src={displayImage(data?.image)} alt=""
                        loading="lazy"
                        className="object-cover w-full h-full"
                        onLoad={() => setImageLoading(false)}
                        whileHover={{ scale: 1.2 }}
                    />
                </div>
            </Link>
            {/* Contents */}
            <div className="space-y-1">
                <Link to={`/product-category/${data?.name?.toLowerCase()}`}>
                    <h3 className="text-center font-medium sm:text-lg">{data?.name}</h3>
                </Link>
            </div>
        </div>
    );
}

export default CategoryBox;
